const defaultContent = {
  title: 'Software Engineer',
  description: 'Passionate Software Engineer and cross-functional team player, with 3 years of experience of working on Javascript/Typescript/React projects, with a proven potential to grow self and others.',
};
export default defaultContent;
